import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, MenuItem, Select } from "@mui/material";

import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import { changeFilter } from "app/store/dashboard/account_analytic/slice/accountAnalyticSlice";
import { useGetDeviceTypesQuery } from "app/store/dashboard/account_analytic/api/accountAnalyticApi";

const AccountAnalyticDeviceFilter = () => {
  const dispatch = useDispatch();
  const { deviceFilter } = useSelector((state) => state.accountAnalytic);

  const { data } = useGetDeviceTypesQuery({ includeHF: true });

  return (
    data && (
      <FormControl>
        <Select
          disableUnderline
          value={deviceFilter}
          onChange={(e) =>
            dispatch(
              changeFilter({ type: "deviceFilter", value: e.target.value })
            )
          }
          disabled={data?.length <= 1}
          sx={{
            ".MuiSelect-standard": {
              background: "transparent",
              marginRight: "10px",
            },
            ".MuiSelect-select": {
              color: "#94BA33",
              fontSize: "0.875rem",
              fontWeight: 500,
              padding: "4px 8px",
              backgroundColor: "transparent",
            },
            "&::focus": {
              background: "transparent !important",
            },
            ".MuiSelect-icon": {
              color: "#94BA33",
            },
          }}
          variant="standard"
          IconComponent={KeyboardArrowDownIcon}
        >
          {data?.length > 1 && <MenuItem value="all">All Devices</MenuItem>}
          {data?.map((device, index) => (
            <MenuItem key={index} value={device}>
              {device}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  );
};

export default AccountAnalyticDeviceFilter;
